import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  EditModeSelectionState,
  MaterialAnnotationType,
  MaterialDropdownState,
} from '../material-annotation-list.model';
import { MaterialAnnotationListDropdownComponent } from './dropdown/material-annotation-list-dropdown.component';
import { MaterialAnnotationListMenuComponent } from './menu/material-annotation-list-menu.component';

@Component({
  selector: 'rdrx-material-annotations-list-header',
  template: `
    <div class="header go-to-active">
      <rdrx-material-annotation-list-dropdown
        [type]="type"
        [isEditMode]="isEditMode"
        [editModeSelections]="editModeSelections"
        (annotationsDropdownState)="dropdownOptionSelected.emit($event)"
        (allAnnotationsSelected)="allAnnotationsSelected.emit($event)" />

      <rdrx-material-annotation-list-menu
        *ngIf="!isEmpty"
        [type]="type"
        (editModeMenuSelected)="editModeSelected.emit()"
        (exportAnnotations)="exportAnnotations.emit(type)"
      />
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;

        .header {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #ddd;
          background-color: #ffffff;
        }
      }
    `,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MaterialAnnotationListDropdownComponent,
    MaterialAnnotationListMenuComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class MaterialAnnotationListHeaderComponent {
  @Input({ required: true }) type!: MaterialAnnotationType;
  @Input({ required: true }) headerClass!: boolean;
  @Input({ required: true }) isEditMode!: boolean;
  @Input({ required: true }) editModeSelections!: EditModeSelectionState;
  @Input({ required: true }) isEmpty!: boolean;

  @Output() editModeSelected = new EventEmitter<boolean>();
  @Output() dropdownOptionSelected = new EventEmitter<MaterialDropdownState>();
  @Output() allAnnotationsSelected = new EventEmitter();
  @Output() exportAnnotations = new EventEmitter<MaterialAnnotationType>();
}
